module.exports = __webpack_public_path__ + "img/spin_btn.88e6df04.png";